/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import constants from '../../constants';

export default {
  setChatSearchQuery ({ commit }, query) {
    commit('SET_CHAT_SEARCH_QUERY', query)
  },
  updateAboutChat ({ commit, rootState }, value) {
    commit('UPDATE_ABOUT_CHAT', {
      rootState,
      value
    })
  },
  updateStatusChat ({ commit, rootState }, value) {
    commit('UPDATE_STATUS_CHAT', {
      rootState,
      value
    })
  },

  // API CALLS
  sendChatMessage ({ getters, commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${constants.apiHost}/chat-messages`, payload)
        .then((response) => {
          // payload.chatData = getters.chatDataOfUser(payload.id)
          // if (!payload.chatData) { dispatch('fetchChatContacts') }
          commit('SEND_CHAT_MESSAGE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  // Get contacts from server. Also change in store
  fetchContacts ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/apps/chat/contacts', {params: {q: ''}})
        .then((response) => {
          commit('UPDATE_CONTACTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  async createChatContact ({ commit }, payload) {
    try {
      const chatContact = await axios.post(`${constants.apiHost}/chat-contacts`, payload);
      commit('ADD_CHAT_CONTACT', chatContact.data)
      return chatContact;
    } catch (error) {
      throw error;
    }
  },

  // Get chat-contacts from server. Also change in store
  async fetchChatContactsByUserIdOrganizationId ({ commit },  { organizationId, userId }) {
    try {
      const chatContacts = await axios.get(`${constants.apiHost}/chat-contacts`, { params: { organizationId, userId }});
      // commit('UPDATE_CHAT_CONTACTS', chatContacts.data.data)
      return chatContacts.data;
    } catch (error) {
      throw error;
    }
  },

  async fetchChatContactsByOrganizationId ({ commit },  { organizationId }) {
    try {
      const chatContacts = await axios.get(`${constants.apiHost}/chat-contacts`, { params: { organizationId }});
      commit('UPDATE_CHAT_CONTACTS', chatContacts.data.data)
      return chatContacts.data;
    } catch (error) {
      throw error;
    }
  },

  async fetchChatContactsByUserId ({ commit },  userId) {
    try {
      // console.log('userid', userId);
      const chatContacts = await axios.get(`${constants.apiHost}/chat-contacts`, { params: { userId }});
      commit('UPDATE_CHAT_CONTACTS', chatContacts.data.data)
      return chatContacts.data;
    } catch (error) {
      throw error;
    }
  },

  // Get chats from server. Also change in store
  async fetchChatsByOrganizationId ({ commit }, organizationId) {
    try {
      const chats = await axios.get(`${constants.apiHost}/chat-messages`, { params: { organizationId }});
      commit('UPDATE_CHATS', chats.data.data)
      return chats.data;
    } catch (error) {
      throw error;
    }
  },

  // Get chats from server. Also change in store
  async fetchChatsByUserId ({ commit }, { userId }) {
    try {
      const chats = await axios.get(`${constants.apiHost}/chat-messages`, { params: { sentByUserId: userId, receivedByUserId: userId }});
      commit('UPDATE_CHATS', chats.data.data)
      return chats.data;
    } catch (error) {
      throw error;
    }
  },

  markSeenAllMessages ({ getters, commit }, id) {

    return new Promise((resolve, reject) => {
      axios.post('/api/apps/chat/mark-all-seen', {id})
        .then((response) => {
          commit('MARK_SEEN_ALL_MESSAGES', {
            id,
            chatData: getters.chatDataOfUser(id)
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  toggleIsPinned ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/apps/chat/set-pinned/', {contactId: payload.id,
        value: payload.value})
        .then((response) => {
          commit('TOGGLE_IS_PINNED', payload)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
